const pageNameKey = "ourNodeDetailsPanel";

export const ourNodeDetailsPanelEn = {
  [pageNameKey]: {
    nameLabel: "Name",
    smallestSampleIntervalLabel: "Smallest Sample Interval",
    dataTypeLabel: "Data Type",
    loading: "Loading...",
    lastKnownTimestampUnavailable: "Last known value (timestamp unavailable)",
    noLastKnownValueAvailable: "No last known value available",
    lastKnownValue: "Last known value",
    dataNotDisplayable: "Data not displayable",
    noJsonDataAvailable: "No Json data available",
    lastKnownJsonValue: "Last known JSON value",
    warningNoEmptyNodeName: "Node name cannot be empty",
    nodeIdBlock: {
      tooltip: "Copy to clipboard",
      child: {
        label: "ID",
      },
      parent: {
        label: "Parent",
      },
    },
    nodeIdSnackBarSuccess: "Node ID copied to clipboard",
    nodeIdSnackBarError:
      "It was not possible to copy the Node ID to the clipboard",
    databit: "Data Acquisition Type",
    pollDataEvery: "Poll Data Every",
    newLocation: "New Location",
    originalLocation: "Original Location in Initial Structure",
    monitoringInfoText: "Data is pushed as soon as an update is available.",
    timeSeriesDataLabelText: "Time Series Data (Last available data)",
    timeSeriesDataUnitLabel: "Unit",
    timeSeriesDataTimeLabel: "Time",
    selectTileLabel: "Select Tile",
    selectChartTypeLabel: "Select Chart Type",
    cancelButtonText: "Cancel",
    removeButtonText: "Remove",
    saveButtonText: "Save",
    unknown: "Unknown",
  },
};

export const ourNodeDetailsPanelPtBr = {
  [pageNameKey]: {
    nameLabel: "Nome",
    smallestSampleIntervalLabel: "Menor intervalo de amostragem",
    dataTypeLabel: "Tipo de dado",
    loading: "Carregando...",
    lastKnownTimestampUnavailable:
      "Último valor conhecido (carimbo de data/hora indisponível)",
    noLastKnownValueAvailable: "Nenhum último valor conhecido disponível",
    lastKnownValue: "Último valor conhecido",
    dataNotDisplayable: "Dados não exibíveis",
    noJsonDataAvailable: "Nenhum dado JSON disponível",
    lastKnownJsonValue: "Último valor JSON conhecido",
    warningNoEmptyNodeName: "O nome do nó não pode ficar vazio",
    nodeIdBlock: {
      tooltip: "Copiar para a área de transferência",
      child: {
        label: "ID",
      },
      parent: {
        label: "Pai/mãe",
      },
    },
    nodeIdSnackBarSuccess: "ID do nó copiado para a área de transferência",
    nodeIdSnackBarError:
      "Não foi possível copiar o ID do nó para a área de transferência",
    databit: "Tipo de aquisição de dados",
    pollDataEvery: "Buscar dados a cada",
    newLocation: "Novo local",
    originalLocation: "Local original na estrutura inicial",
    monitoringInfoText:
      "Os dados são enviados assim que uma atualização está disponível.",
    timeSeriesDataLabelText:
      "Dados de Séries Temporais (Últimos dados disponíveis)",
    timeSeriesDataUnitLabel: "Unidade",
    timeSeriesDataTimeLabel: "Tempo",
    selectTileLabel: "Selecionar bloco",
    selectChartTypeLabel: "Selecionar tipo de gráfico",
    cancelButtonText: "Cancelar",
    removeButtonText: "Remover",
    saveButtonText: "Salvar",
    unknown: "Desconhecido",
  },
};

export const ourNodeDetailsPanelDe = {
  [pageNameKey]: {
    nameLabel: "Name",
    smallestSampleIntervalLabel: "Kleinster Sample-Intervall",
    dataTypeLabel: "Daten Typ",
    loading: "Laden...",
    lastKnownTimestampUnavailable:
      "Letzter bekannter Wert (Zeitstempel nicht verfügbar)",
    noLastKnownValueAvailable: "Kein letzter bekannter Wert verfügbar",
    lastKnownValue: "Letzter bekannter Wert",
    dataNotDisplayable: "Daten nicht anzeigbar",
    noJsonDataAvailable: "Keine Json-Daten verfügbar",
    lastKnownJsonValue: "Letzter bekannter JSON-Wert",
    warningNoEmptyNodeName: "Knotenname darf nicht leer sein",
    nodeIdBlock: {
      tooltip: "In die Zwischenablage kopieren",
      child: {
        label: "ID",
      },
      parent: {
        label: "Parent",
      },
    },
    nodeIdSnackBarSuccess: "Node ID in die Zwischenablage kopiert",
    nodeIdSnackBarError:
      "Es war nicht möglich, die Node ID in die Zwischenablage zu kopieren",
    databit: "Datenakquisitionstyp",
    pollDataEvery: "Poll Daten alle",
    newLocation: "Neue Position",
    originalLocation: "Ursprüngliche Position in der Ausgangsstruktur",
    monitoringInfoText:
      "Daten werden aktualisiert, sobald eine Aktualisierung verfügbar ist.",
    timeSeriesDataLabelText: "Time Series Daten (Letzte verfügbare Daten)",
    timeSeriesDataUnitLabel: "Einheit",
    timeSeriesDataTimeLabel: "Zeit",
    selectTileLabel: "Kachel auswählen",
    selectChartTypeLabel: "Diagrammtyp auswählen",
    cancelButtonText: "Abbrechen",
    removeButtonText: "Entfernen",
    saveButtonText: "Speichern",
    unknown: "Unbekannt",
  },
};

export const ourNodeDetailsPanelZhHans = {
  [pageNameKey]: {
    nameLabel: "名称",
    smallestSampleIntervalLabel: "最小采样间隔",
    dataTypeLabel: "数据类型",
    loading: "加载中...",
    lastKnownTimestampUnavailable: "最后已知值（时间戳不可用）",
    noLastKnownValueAvailable: "没有可用的最后已知值",
    lastKnownValue: "最后已知值",
    dataNotDisplayable: "数据不可显示",
    noJsonDataAvailable: "没有可用的Json数据",
    lastKnownJsonValue: "最后已知JSON值",
    warningNoEmptyNodeName: "节点名称不能为空",
    nodeIdBlock: {
      tooltip: "复制到剪贴板",
      child: {
        label: "ID",
      },
      parent: {
        label: "父节点",
      },
    },
    nodeIdSnackBarSuccess: "节点ID已复制到剪贴板",
    nodeIdSnackBarError: "无法将节点ID复制到剪贴板",
    databit: "数据采集类型",
    pollDataEvery: "每隔多久轮询数据",
    newLocation: "新位置",
    originalLocation: "初始结构中的原始位置",
    monitoringInfoText: "数据在更新可用时立即推送。",
    timeSeriesDataLabelText: "时间序列数据（最后可用数据）",
    timeSeriesDataUnitLabel: "单位",
    timeSeriesDataTimeLabel: "时间",
    selectTileLabel: "选择图块",
    selectChartTypeLabel: "选择图表类型",
    cancelButtonText: "取消",
    removeButtonText: "移除",
    saveButtonText: "保存",
    unknown: "未知",
  },
};

export const ourNodeDetailsPanelIt = {
  [pageNameKey]: {
    nameLabel: "Nome",
    smallestSampleIntervalLabel: "Intervallo minimo di campionamento",
    dataTypeLabel: "Tipologia dato",
    loading: "Caricamento...",
    lastKnownTimestampUnavailable:
      "Ultimo valore noto (timestamp non disponibile)",
    noLastKnownValueAvailable: "Nessun valore disponibile",
    lastKnownValue: "Ultimo valore noto",
    dataNotDisplayable: "Dati non visualizzabili",
    noJsonDataAvailable: "Nessun dato in formatoJSON disponibile",
    lastKnownJsonValue: "Ultimo valore JSON noto",
    warningNoEmptyNodeName: "Il nome del nodo non può essere vuoto",
    nodeIdBlock: {
      tooltip: "Copia negli appunti",
      child: {
        label: "ID",
      },
      parent: {
        label: "Genitore",
      },
    },
    nodeIdSnackBarSuccess: "Nodo ID copiato negli appunti",
    nodeIdSnackBarError:
      "Non è stato possibile copiare il nodo ID negli appunti",
    databit: "Tipo di acquisizione dati",
    pollDataEvery: "Frequenza polling",
    newLocation: "Posizione nella struttura attiva",
    originalLocation: "Posizione originale nella struttura iniziale",
    monitoringInfoText:
      "I dati vengono inviati non appena viene reso disponibile un aggiornamento.",
    timeSeriesDataLabelText:
      "Dati di serie temporali (ultimo dato disponibile)",
    timeSeriesDataUnitLabel: "unità",
    timeSeriesDataTimeLabel: "Data",
    selectTileLabel: "Seleziona scheda",
    selectChartTypeLabel: "Seleziona tipo di grafico",
    cancelButtonText: "Annulla",
    removeButtonText: "Rimuovi",
    saveButtonText: "Salva",
    unknown: "Sconosciuto",
  },
};

export const ourNodeDetailsPanelEs = {
  [pageNameKey]: {
    nameLabel: "Nombre",
    smallestSampleIntervalLabel: "Intervalo de muestra más pequeño",
    dataTypeLabel: "Tipo de dato",
    loading: "Cargando...",
    lastKnownTimestampUnavailable:
      "Último valor conocido (marca de tiempo no disponible)",
    noLastKnownValueAvailable: "No hay ningún último valor conocido disponible",
    lastKnownValue: "Último valor conocido",
    dataNotDisplayable: "Datos no visibles",
    noJsonDataAvailable: "No hay datos JSON disponibles",
    lastKnownJsonValue: "Último valor JSON conocido",
    warningNoEmptyNodeName: "El nombre del nodo no puede estar vacío",
    nodeIdBlock: {
      tooltip: "Copiar al portapapeles",
      child: {
        label: "ID",
      },
      parent: {
        label: "Padre",
      },
    },
    nodeIdSnackBarSuccess: "Nodo ID copiado al portapapeles",
    nodeIdSnackBarError: "No fue posible copiar el nodo ID al portapapeles",
    databit: "Tipo de adquisición de datos",
    pollDataEvery: "Intervalo de sondeo",
    newLocation: "Nueva ubicación",
    originalLocation: "Ubicación original en la estructura inicial",
    monitoringInfoText:
      "Los datos se envían en cuanto hay una actualización disponible.",
    timeSeriesDataLabelText:
      "Datos de series temporales (Últimos datos disponibles)",
    timeSeriesDataUnitLabel: "Unidad",
    timeSeriesDataTimeLabel: "Hora",
    selectTileLabel: "Seleccionar mosaico",
    selectChartTypeLabel: "Seleccionar tipo de gráfico",
    cancelButtonText: "Cancelar",
    removeButtonText: "Eliminar",
    saveButtonText: "Guardar",
    unknown: "Desconocido",
  },
};

export const ourNodeDetailsPanelNl = {
  [pageNameKey]: {
    cancelButtonText: "Annuleren",
    dataNotDisplayable: "Gegevens kunnen niet worden weergegeven",
    dataTypeLabel: "Gegevenstype",
    databit: "Type gegevensverzameling",
    lastKnownJsonValue: "Laatst bekende JSON-waarde",
    lastKnownTimestampUnavailable:
      "Laatst bekende waarde (tijdstempel niet beschikbaar)",
    lastKnownValue: "Laatst bekende waarde",
    loading: "Laden...",
    monitoringInfoText:
      "Gegevens worden verzonden zodra er een update beschikbaar is.",
    nameLabel: "Naam",
    newLocation: "Nieuwe locatie",
    noJsonDataAvailable: "Geen JSON-gegevens beschikbaar",
    noLastKnownValueAvailable: "Geen laatst bekende waarde beschikbaar",
    nodeIdBlock: {
      tooltip: "Kopiëren naar klembord",
      child: {
        label: "ID",
      },
      parent: {
        label: "Bovenliggend",
      },
    },
    nodeIdSnackBarError:
      "Het was niet mogelijk om de node-ID naar het klembord te kopiëren",
    nodeIdSnackBarSuccess: "Node-ID gekopieerd naar klembord",
    originalLocation: "Oorspronkelijke locatie in initiële structuur",
    pollDataEvery: "Gegevens ophalen alle",
    removeButtonText: "Verwijderen",
    saveButtonText: "Opslaan",
    selectChartTypeLabel: "Grafiektype selecteren",
    selectTileLabel: "Tegel selecteren",
    smallestSampleIntervalLabel: "Kleinste sample-interval",
    timeSeriesDataLabelText: "Tijdreeksgegevens (laatst beschikbare gegevens)",
    timeSeriesDataTimeLabel: "Tijd",
    timeSeriesDataUnitLabel: "Eenheid",
    unknown: "Onbekend",
    warningNoEmptyNodeName: "Nodenaam mag niet leeg zijn",
  },
};

export const ourNodeDetailsPanelTr = {
  [pageNameKey]: {
    cancelButtonText: "İptal etmek",
    dataNotDisplayable: "Veri görüntülenemiyor",
    dataTypeLabel: "Veri Türü",
    databit: "Veri Toplama Türü",
    nodeIdBlock: {
      parent: {
        label: "Ebeveyn",
      },
      tooltip: "Panoya kopyala",
      child: {
        label: "ID",
      },
    },
    lastKnownJsonValue: "Bilinen son JSON değeri",
    lastKnownTimestampUnavailable:
      "Bilinen son değer (zaman damgası mevcut değil)",
    lastKnownValue: "Bilinen son değer",
    loading: "Yükleniyor...",
    monitoringInfoText: "Bir güncelleme mevcut olur olmaz veriler iletilir.",
    nameLabel: "İsim",
    newLocation: "Yeni Konum",
    noJsonDataAvailable: "Json verisi yok",
    noLastKnownValueAvailable: "Bilinen son değer mevcut değil",
    nodeIdSnackBarError: "Düğüm kimliğini panoya kopyalamak mümkün olmadı",
    nodeIdSnackBarSuccess: "Düğüm kimliği panoya kopyalandı",
    originalLocation: "İlk Yapıdaki Orijinal Yer",
    pollDataEvery: "Anket Verileri",
    removeButtonText: "Kaldırmak",
    saveButtonText: "Kaydetmek",
    selectChartTypeLabel: "Grafik Türünü Seçin",
    selectTileLabel: "Döşeme Seç",
    smallestSampleIntervalLabel: "En Küçük Örnek Aralığı",
    timeSeriesDataLabelText: "Zaman Serisi Verileri (Mevcut son veriler)",
    timeSeriesDataTimeLabel: "Zaman",
    timeSeriesDataUnitLabel: "Birim",
    unknown: "Bilinmiyor",
    warningNoEmptyNodeName: "Düğüm adı boş olamaz",
  },
};
